import { OrganizationDetailData, SalutationType } from 'data-model';
import { OrganizationContact } from '../model/organization-contact.model';

export const MOCK_ORGANIZATION_CONTACT: OrganizationContact = {
  responsibleServices: ['Good service', 'Awesome service', 'Perfect service'],
  salutation: SalutationType.m,
  firstname: 'John',
  lastname: 'Wick',
  email: 'john.wick@email.com',
  language: 'en-gb',
  phone: '+49 08007238928',
  address: null,
};

export const MOCK_ORGANIZATION_DETAILS_DATA = {
  id: '654z5ez45u45654',
  name: 'Markant Group',
  phone: '1234567890123',
  address: {
    street: 'Musterstraße',
    streetNumber: '12',
    zipCode: '12345',
    city: 'Musterstadt',
    countryCode: 'DE',
  },
} as OrganizationDetailData;
